module.exports = __webpack_public_path__ + "img/1717383939163-nib keripik opatan.png.ec3d7be3.webp";